import { useQuery } from "@tanstack/react-query";
import { facilityApi } from "@bw/shared/api";
import type { BookingResponse } from "@bw/shared/types/generated";
import { queryKeys } from "../../../common/query/queryClient";

/**
 * One court booking (GET /facilities/bookings/{id}), backing the booking-detail
 * hub header. The booking carries the canonical court_name, the venue-local
 * start/end, the server status, and the host's user_id (the host-only gate
 * compares it to the viewer uid — a UX hint only; the backend owns real authz).
 *
 * Keyed by the booking id so each open booking is card-isolated. Read-only; the
 * roster mutations invalidate `participants`, not this slot. A 404 (booking
 * gone) rejects so the page can show its distinct not-found state — never a
 * crash or a fabricated booking.
 */
export function useBookingDetail(bookingId: string | undefined) {
  return useQuery<BookingResponse>({
    queryKey: queryKeys.booking.detail(bookingId ?? ""),
    queryFn: () => facilityApi.getBooking(bookingId as string),
    enabled: Boolean(bookingId),
  });
}
